// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2XDsa","label":"SetPasswdForm_label__sBxRK"};